module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/iterators.js
// module id = 175
// module chunks = 1